import { render, staticRenderFns } from "./CaliperDetailsPressureComponent.vue?vue&type=template&id=20c31a60&scoped=true"
import script from "./CaliperDetailsPressureComponent.js?vue&type=script&lang=js&external"
export * from "./CaliperDetailsPressureComponent.js?vue&type=script&lang=js&external"
import style0 from "./CaliperDetailsPressureComponent.vue?vue&type=style&index=0&id=20c31a60&prod&lang=scss&scoped=true"
import style1 from "./CaliperDetailsPressureComponent.vue?vue&type=style&index=1&id=20c31a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c31a60",
  null
  
)

export default component.exports